module.exports = __webpack_public_path__ + "img/3d.41336137.png";